export default "__VITE_ASSET__241c3d5f__"